import React, {FC, memo} from "react";
import {BirthdayCardContainer, BirthdayCardContext, BirthdayCardItem, BirthdayCardText} from "./BirthdayCardStyle";
import moment, {Moment} from "moment/moment";
import ContextMenuBirthday from "../ContextMenu/ContextMenuBirthday";
import {IPersonProps} from "../../modal/modalPerson/ModalPerson";


const BirthdayCard: FC<IPersonProps> = (person) => {

    const {name, eventName, birthdayDate} = person.person;

    const date = (date: string): string => {
        return moment(date).format("DD.MM.yyyy")
    }

    const dateText = (date: string): string => {
        const momentDate = moment(date);
        let stringJoin = ''

        const year = actualYear(momentDate)
        const month = actualMonth(momentDate)
        const day = actualDay(momentDate)

        if (year > 0) {
            stringJoin += `${year} ${yearText(year)} `;
        }
        if (month > 0) {
            stringJoin += `${month} ${monthText(month)} `;
        }
        if (day > 0) {
            stringJoin += `${day} ${dayText(day)}`;
        }

        if (moment().month() === momentDate.month() && moment().date() === momentDate.date() ) {
            return "День Рождения"
        }

        return stringJoin;
    }

    const actualYear = (birthdayDate: moment.Moment) => {
        if (birthdayDate.month() > moment().month() ||
            (birthdayDate.month() == moment().month() && birthdayDate.date() > moment().date())) {
            return moment().year() - birthdayDate.year() -1
        }
        return moment().year() - birthdayDate.year()
    }

    const yearText = (year: number): string => {
        const patternOne = /(\d+)1|(1$)/g;
        if (year.toString().match(patternOne) && year !== 11) {
            return "год"
        }

        const patternMany = /(^[2-4]$)|([^1](\d+)?[2-4]$)/g;
        if (year.toString().match(patternMany)) {
            return "года"
        }
        return "лет";
    }

    const monthText = (month: number): string => {
        if (month === 1) {
            return "месяц"
        }
        if ([2,3,4].includes(month)) {
            return "месяца"
        }
        return "месяцев";
    }

    const dayText = (day: number): string => {
        const patternOne = /(\d+)1|(1$)/g;
        if (day.toString().match(patternOne)) {
            return "день"
        }

        const patternMany = /(^[2-4]$)|(2[2-4])/g;
        if (day.toString().match(patternMany)) {
            return "дня"
        }
        return "дней";
    }

    const actualMonth = (birthdayDate: moment.Moment) => {

        if (birthdayDate.month() > moment().month() ||
            (birthdayDate.month() == moment().month() && birthdayDate.date() > moment().date())) {
            return  moment().month() + 11 - birthdayDate.month()
        }
        return moment().month() - birthdayDate.month()
    }

    const actualDay = (birthdayDate: moment.Moment) => {

        if (birthdayDate.date() > moment().date()) {
            return moment().date() + birthdayDate.daysInMonth() - birthdayDate.date()
        }
        return moment().date() - birthdayDate.date()
    }

    return (
        <BirthdayCardContainer>
            <ContextMenuBirthday person={person.person}>
                <BirthdayCardContext>
                    <BirthdayCardItem>
                        <BirthdayCardText>{name}</BirthdayCardText>
                        <BirthdayCardText color={"gray"}>{eventName}</BirthdayCardText>
                    </BirthdayCardItem>

                    <BirthdayCardItem>
                        <BirthdayCardText style={{alignSelf: "end"}}>{date(birthdayDate)}</BirthdayCardText>
                        <BirthdayCardText color={"gray"}>{dateText(birthdayDate)}</BirthdayCardText>
                    </BirthdayCardItem>
                </BirthdayCardContext>
            </ContextMenuBirthday>
        </BirthdayCardContainer>
    )
}

export default memo(BirthdayCard)
